<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <div class="content-page-header">
            <h5>Expenses</h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <a class="btn-filters w-auto popup-toggle"
                    ><span><i class="feather feather-filter"></i></span>
                  </a>
                </li>
                <li>
                  <a
                    @click="openModal(null, 'export')"
                    class="btn-filters w-auto"
                    ><span><i class="feather feather-download-cloud"></i></span>
                  </a>
                </li>
                <li>
                  <a @click="openAddModal" class="btn btn-primary"
                    ><i class="fa fa-plus-circle me-2" aria-hidden="true"></i
                    >Add Expenses</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Add Asset -->
        <div class="toggle-sidebar">
          <div class="sidebar-layout-filter">
            <div class="sidebar-header">
              <h5>Filter</h5>
              <a href="javascript:;" class="sidebar-closes"
                ><i class="fa-regular fa-circle-xmark"></i
              ></a>
            </div>
            <div class="sidebar-body">
              <b-form action="#" autocomplete="off">
                <!-- Customer -->
                <div class="accordion" id="accordionMain1">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div class="card-header-new" id="headingOne">
                      <h6 class="filter-title">
                        Expense
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample1"
                  >
                    <div class="card-body-chat">
                      <div class="row">
                        <div class="col-md-12">
                          <div id="checkBoxes1">
                            <div class="form-custom">
                              <input
                                type="text"
                                class="form-control"
                                v-model="searchForm.search"
                                id="member_search1"
                                placeholder="Search here"
                              />
                              <span
                                ><img
                                  src="@/assets/img/icons/search.svg"
                                  alt="img"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Customer -->

                <!-- Select Date -->
                <div class="accordion" id="accordionMain2">
                  <a
                    href="javascript:void(0);"
                    class="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    <div class="card-header-new" id="headingTwo">
                      <h6 class="filter-title">
                        Select Date
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div class="card-body-chat">
                      <div class="form-group">
                        <label class="form-control-label">From</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="searchForm.from"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">To</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="searchForm.to"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Select Date -->

                <!-- Category -->
                <div class="accordion accordion-last" id="accordionMain4">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="true"
                    aria-controls="collapseFour"
                  >
                    <div class="card-header-new" id="headingFour">
                      <h6 class="filter-title">
                        Status
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseFour"
                    class="collapse show"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample4"
                  >
                    <div class="card-body-chat">
                      <div id="checkBoxes1">
                        <div class="form-custom">
                          <b-form-select
                            class="search-select"
                            v-model="searchForm.status"
                            :options="statusOptions"
                          ></b-form-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Category -->

                <button
                  @click="resetSearchForm"
                  class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
                >
                  <span><i class="feather feather-refresh-ccw me-2"></i></span
                  >Reset
                </button>
              </b-form>
            </div>
          </div>
        </div>
        <!--/Add Asset -->

        <!-- Table -->
        <div class="row">
       			        <div class="col-md-3 mb-3">
                
          <div class="form-custom">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search anything..."
             		v-model="searchForm.search"
            />
        
          </div>
        </div>
				
          <div class="col-sm-12">
            <div class="card-table">
              <div class="card-body">
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columns"
                    :loading="isFetching"
                    :data-source="expenses.data"
                    :pagination="false"
                  >
                    <template #bodyCell="{ column, record, index }">
                      <template v-if="column.key === 'index'">
                        {{ index + 1 }}
                      </template>
                      <template v-if="column.key === 'customer'">
                        <router-link
                          style="color: #878a99"
                          :to="`/customer-details/` + record.customer.id"
                        >
                          {{ record.customer.name }}
                        </router-link>
                      </template>
                      <template v-if="column.key === 'date'">
                        {{ formatted(record.date) }}
                      </template>
                      <template v-if="column.key === 'amount'">
                        {{ record.currency.slice(0, 3) }}
                        {{ addCurrencyComma(record.amount) }}
                      </template>
                      <template v-else-if="column.key === 'status'">
                        <span
                          class="badge bg-success-light text-success-light text-capitalize"
                          v-if="
                            record.status === 'paid' ||
                            record.status === 'refunded' ||
                            record.status === 'sent' ||
                            record.status === 'viewed' ||
                            record.status === 'accepted'
                          "
                          >{{ record.status }}</span
                        >
                        <span
                          class="badge bg-warning-light text-warning-light text-capitalize"
                          v-else-if="
                            record.status === 'draft' ||
                            record.status === 'pending' ||
                            record.status === 'unpaid' ||
                            record.status === 'recurring'
                          "
                          >{{ record.status }}</span
                        >
                        <span
                          class="badge bg-warning-light text-warning-light text-capitalize"
                          v-else-if="record.status === 'partially_paid'"
                          >Partially paid</span
                        >
                        <span
                          class="badge bg-danger-light text-capitalize"
                          v-else-if="
                            record.status === 'expired' ||
                            record.status === 'rejected' ||
                            record.status === 'overdue'
                          "
                          >{{ record.status }}</span
                        >
                      </template>
                      <template v-else-if="column.key === 'action'">
                        <div
                          class="d-flex align-items-center justify-content-start"
                        >
                          <div class="dropdown dropdown-action">
                            <a
                              href="javascript:;"
                              class="btn-action-icon"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              >Action</a
                            >
                            <div class="dropdown-menu dropdown-menu-right">
                              <ul>
                                <li>
                                  <a
                                    @click="openViewModal(record)"
                                    class="dropdown-item"
                                    ><i class="far fa-eye me-2"></i>View</a
                                  >
                                </li>
                                <li>
                                  <a
                                    @click="openEditModal(record)"
                                    class="dropdown-item"
                                    ><i class="far fa-edit me-2"></i>Edit</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'duplicate')"
                                    ><i class="far fa-clone me-2"></i
                                    >Duplicate</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'refund')"
                                    ><i class="fa fa-undo me-2"></i>Mark as
                                    refunded</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'delete')"
                                    ><i class="far fa-trash-alt me-2"></i
                                    >Delete</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
                <div class="d-flex justify-content-end">
                  <a-pagination
                    class="mt-4"
                    :current="currentPage"
                    :total="total"
                    :page-size="perPage"
                    :show-size-changer="false"
                    :show-quick-jumper="false"
                    @change="handlePageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>

  <!-- Delete Expense Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Expense</span>
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Expense</span
              >
              <span v-if="selectedAction === 'refund'">Refund Expense</span>
              <span v-if="selectedAction === 'export'">Export Expense</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'refund'">refund</span>
              {{ selectedItem.customer.name }}?
            </p>
            <p v-if="selectedItem === null">
              Are you sure want to
              <span v-if="selectedAction === 'export'">export</span> Expenses?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteExpense"
                  class="w-100 btn btn-danger"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Delete</span>
                  <span v-if="isLoading">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'refund'"
                  @click="markAsRefunded"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Refund</span>
                  <span v-if="isLoading">Refunding...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateExpense"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Duplicate</span>
                  <span v-if="isLoading">Duplicating...</span>
                </button>
                <button
                  v-if="selectedAction === 'export'"
                  @click="exportExpense"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Export</span>
                  <span v-if="isLoading">Exporting...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Expense Modal -->
  <addexpensemodal @closeAddModal="closeAddModal" />
  <ViewExpensemodal :expense="expense_view" />
  <EditExpensesModal
    :expenseID="expenseID"
    :form="form"
    @closeEditModal="closeEditModal"
  />

  <!-- /Main Wrapper -->
</template>
<script setup>
import { computed, ref, onMounted, watch } from "vue";
import EditExpensesModal from "./edit-expenses.vue";
import {
  formatted,
  formatDateToDashDigits,
  formatDateStrings,
} from "@/assets/composables/date";
import { addCurrencyComma } from "@/assets/composables/currency";
import ViewExpensemodal from "./view-expense.vue";
import { useStore } from "vuex";
import { Modal } from "bootstrap";

const store = useStore();
const isFetching = ref(false);
const currentPage = ref(1);
const perPage = ref(50);
const selectedAction = ref(null);
const modalInstance = ref(null);
const addModalInstance = ref(null);
const editModalInstance = ref(null);
const viewModalInstance = ref(null);
const isLoading = ref(null);
const selectedItem = ref(null);
const expenseID = ref(null);
const editkey = ref(0);
const expense_view = ref(null);

const emptyEditForm = () => ({
  customer_id: "",
  date: "",
  amount: "",
  notes: "",
  recurring: "0",
  recurring_duration: {
    mode: null,
    value: null,
  },
  attachment: "",
});

const form = ref(emptyEditForm);

const resetSearchForm = () => {
  searchForm.value = {
    search: "",
    status: "",
    from: "",
    to: "",
  };
};

const searchForm = ref({
  search: "",
  status: "",
  from: "",
  to: "",
});

watch(
  () => searchForm.value,
  (newValue) => {
    isFetching.value = true;
    let data = {
      current_page: currentPage.value,
      per_page: perPage.value,
      query: newValue.search,
      filter: {
        date: {
          mode: "range",
          range: {
            from:
              newValue.from != "" ? formatDateToDashDigits(newValue.from) : "",
            to: newValue.to != "" ? formatDateToDashDigits(newValue.to) : "",
          },
        },
      },
    };
    if (newValue.status != "") {
      data.filter.status = [newValue.status];
    }
    store.dispatch("expenses/getExpenses", data).then(() => {
      isFetching.value = false;
    });
  },
  { deep: true }
);

const statusOptions = [
  { value: "", text: "Please select status" },
  { value: "pending", text: "Pending" },
  { value: "expired", text: "Expired" },
];

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Customer",
    key: "customer",
    sorter: true,
  },
  {
    title: "Date Created",
    key: "date",
    sorter: true,
  },
  {
    title: "Amount",
    key: "amount",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const handlePageChange = (page) => {
  currentPage.value = page;
};

watch(currentPage, (newValue) => {
  currentPage.value = newValue;
  getExpenses();
});

const openModal = (expense, name) => {
  selectedAction.value = name;
  selectedItem.value = expense;
  modalInstance.value.show();
};
const closeModal = () => {
  modalInstance.value.hide();
};

const openAddModal = () => {
  addModalInstance.value.show();
};
const closeAddModal = () => {
  addModalInstance.value.hide();
  getExpenses();
};

const openViewModal = async (expense) => {
  expense_view.value = await expense;
  viewModalInstance.value.show();
};
const closeViewModal = () => {
  viewModalInstance.value.hide();
};

const openEditModal = async (expense) => {
  expenseID.value = await expense.id;

  form.value = {
    customer_id: expense.customer.id,
    date: formatDateStrings(expense.date),
    amount: expense.amount,
    currency: expense.currency,
    notes: expense.notes,
    currency: "NGN : Naira",
    recurring: expense?.recurring,
    recurring_duration: {
      mode: expense.recurring_duration.mode,
      value: expense.recurring_duration.value,
    },
    attachment: "",
  };
  editModalInstance.value.show();
};
const closeEditModal = () => {
  editModalInstance.value.hide();
  getExpenses();
};

const expenses = computed(() => {
  return store.getters["expenses/expenses"];
});
const total = computed(() => {
  return store.getters["expenses/total"];
});

const getExpenses = () => {
  isFetching.value = true;
  let data = {
    current_page: currentPage.value,
    per_page: perPage.value,
  };
  store
    .dispatch("expenses/getExpenses", data)
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};

const duplicateExpense = () => {
  isLoading.value = true;
  store
    .dispatch("expenses/duplicateExpense", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getExpenses();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const markAsRefunded = () => {
  isLoading.value = true;
  let data = {
    id: selectedItem.value.id,
    payload: {
      status: "refunded",
    },
  };
  store
    .dispatch("expenses/markAsRefunded", data)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getExpenses();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const deleteExpense = () => {
  isLoading.value = true;
  store
    .dispatch("expenses/deleteExpense", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const exportExpense = async () => {
  isLoading.value = true;
  await store
    .dispatch("expenses/exportExpense")
    .then(() => {
      saveExcel(store.state.expenses.url);
    })
    .then(() => {
      closeModal();
      isLoading.value = false;
    })
    .catch(() => {
      closeModal();
      isLoading.value = false;
    });
};

const saveExcel = (fileUrl) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", "fileName");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

onMounted(() => {
  getExpenses();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }

  // Initiate modal
  modalInstance.value = new Modal(document.getElementById("delete_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  addModalInstance.value = new Modal(document.getElementById("add_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  editModalInstance.value = new Modal(document.getElementById("edit_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  viewModalInstance.value = new Modal(document.getElementById("view_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});

// onUnmounted(() => {
//   localStorage.removeItem("expense_id");
// });
</script>
